<template>
  <div>
    <div style="margin-top: 8px; margin-left: 8px">
      <el-button @click="search(1)"> 查询 </el-button>
      <el-button v-if="ERP.isPermission(4004002001)" @click="modals">
        添加税盘
      </el-button>
    </div>
    <el-descriptions
      style="margin-top: 8px; margin-left: 8px"
      :column="2"
      size="mini"
      border
    >
      <el-descriptions-item label="公司名称/纳税人识别号">
        <el-input
          size="mini"
          v-model="searchForm.keyword"
          placeholder="输入公司名称/纳税人识别号搜索"
        ></el-input>
      </el-descriptions-item>
      <el-descriptions-item label=""> </el-descriptions-item>
    </el-descriptions>
    <el-table
      style="margin-top: 8px; margin-left: 8px"
      max-height="600"
      :data="listData"
      border
    >
      <el-table-column label="公司名称" prop="name" />
      <el-table-column label="纳税人识别号" prop="tax_number" />
      <el-table-column label="地址/电话" prop="address" />
      <el-table-column label="开户行及账号" prop="bank" />
      <el-table-column label="电话/邮箱" prop="tel" />
      <el-table-column label="开票人" prop="drawer" />
      <el-table-column label="收款人" prop="payee" />
      <el-table-column label="复核人" prop="inspector" />
      <el-table-column label="备注" prop="remark" />
      <el-table-column label="操作">
        <template slot-scope="data">
          <el-link
            type="primary"
            :underline="false"
            @click="edit(data.row.id)"
          >
            修改
          </el-link>
          <el-link
            type="primary"
            :underline="false"
            @click="del(data.row.id)"
          >
            删除
          </el-link>
          <el-link
            type="primary"
            :underline="false"
            @click="digitization(data.row)"
          >
            全电票验证
          </el-link>
        </template>
      </el-table-column>
    </el-table>
    <div class="pages" v-if="listData">
      <Page
        :total="searchForm.totalCount"
        :page-size="searchForm.pageSize"
        @on-change="search"
        show-total
      />
    </div>
    <el-dialog
      title="税盘管理"
      :visible.sync="modal"
      width="60%"
      :before-close="handleClose"
    >
      <el-form ref="form" :model="form" label-width="120px" :rules="rules">
        <el-form-item label="公司名称" prop="name">
          <el-input v-model="form.name" />
        </el-form-item>
        <el-form-item label="纳税人识别号" prop="tax_number">
          <el-input v-model="form.tax_number" />
        </el-form-item>
        <el-form-item label="地址/电话" prop="address">
          <el-input v-model="form.address" />
        </el-form-item>
          <el-form-item label="开户行" prop="bank">
            <el-input v-model="form.bank" />
          </el-form-item>
          <el-form-item label="银行账号" prop="bank_account">
            <el-input v-model="form.bank_account" />
          </el-form-item>
        <el-form-item label="电话/邮箱" prop="tel">
          <el-input v-model="form.tel" />
        </el-form-item>
        <el-form-item label="开票人" prop="drawer">
          <el-input v-model="form.drawer" />
        </el-form-item>
        <el-form-item label="收款人" prop="payee">
          <el-input v-model="form.payee" />
        </el-form-item>
        <el-form-item label="复核人" prop="inspector">
          <el-input v-model="form.inspector" />
        </el-form-item>
        <el-form-item label="开票终端" prop="invoice_client">
          <el-input v-model="form.invoice_client" type="textarea" autosize />
        </el-form-item>
        <el-form-item label="关联区域" prop="contract_area_id">
          <el-select
            v-model="form.contract_area_id"
            filterable
            remote
            reserve-keyword
            placeholder="请输入区域名称搜索"
            :remote-method="searchArea"
            :loading="areaLoading"
            clearable
            style="width: 100%;"
          >
            <el-option
              v-for="item in areaOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="appKey" prop="app_key">
          <el-input v-model="form.app_key" />
        </el-form-item>
        <el-form-item label="appSecret" prop="app_secret">
          <el-input v-model="form.app_secret" />
        </el-form-item>
        <el-form-item label="auth_id" prop="auth_id">
          <el-input v-model="form.auth_id" />
        </el-form-item>
        <el-form-item label="用户名" prop="user_name">
          <el-input v-model="form.user_name" />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="form.password" />
        </el-form-item>
        <el-form-item label="盐值" prop="user_salt">
          <el-input v-model="form.user_salt" />
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input v-model="form.sort" type="number"></el-input>
          <div class="el-form-item__info" style="line-height: 1.5;">数字越小优先级越高</div>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveDisc">保存</el-button>
          <el-button @click="handleClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>


    <invoice-digitization
      :dialog-visible.sync="digitizationModel"
      :disc-id="discId"
      @close="closeDigitization"
    />
  </div>
</template>

<script>
import invoiceDigitization from "@/components/Admin/Contract/components/invoiceDigitization.vue";
import { Area } from "./common.js";
export default {
  name: "InvoiceSetting",
  components: { invoiceDigitization },
  data() {
    return {
      modal: false,
      listData: [],
      searchForm: {
        keyword: "",
        page: 1,
        pagesize: 10,
        totalCount: 0,
      },
      form: {
        id: "",
        name: "",
        tax_number: "",
        address: "",
        bank: "",
        tel: "",
        drawer: "",
        payee: "",
        inspector: "",
        remark: "",
        invoice_client: "",
        is_digitization: false,
        bank_account: "",
        app_key: "",
        app_secret: "",
        user_name: "",
        password: "",
        user_salt: "",
        sort : "",
      },
      pindexFrom: {
        id: "",
        pindex_ids: [],
      },
      pindexList: [],
      areaOptions: [],
      areaLoading: false,
      rules: {
        name: [{ required: true, message: "请填写名称", trigger: "blur" }],
        tax_number: [
          { required: true, message: "请填写纳税人识别号", trigger: "blur" },
        ],
        address: [
          { required: true, message: "请填写地址/电话", trigger: "blur" },
        ],
        bank: [{ required: true, message: "请填写开户行", trigger: "blur" }],
        bank_account: [
          { required: true, message: "请填写银行账号", trigger: "blur" },
        ],
        tel: [{ required: true, message: "请填写电话/邮箱", trigger: "blur" }],
        drawer: [{ required: true, message: "请填写开票人", trigger: "blur" }],
        payee: [{ required: true, message: "请填写收款人", trigger: "blur" }],
        inspector: [
          { required: true, message: "请填写复核人", trigger: "blur" },
        ],
        invoice_client: [
          { required: true, message: "请填写开票终端", trigger: "blur" },
        ],
        contract_area_id: [
          { required: true, message: "请选择关联区域", trigger: "change" },
        ],
        app_key: [{ required: true, message: "请填写 appKey", trigger: "blur" }],
        auth_id: [{ required: true, message: "请填写 auth_id", trigger: "blur" }],
        app_secret: [
          { required: true, message: "请填写 appSecret", trigger: "blur" },
        ],
        user_name: [
          { required: true, message: "请填写用户名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请填写密码", trigger: "blur" }],
        user_salt: [{ required: true, message: "请填写盐值", trigger: "blur" }],
      },
      defaultCheckedKeys: [],
      digitizationModel: false,
      discId: "",
    };
  },
  mounted() {
    this.search(1);
  },
  watch: {},
  methods: {
    saveDisc() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          // 将 pindex_ids 数组转换为 JSON 字符串
          let formData = { ...this.form };
          if (formData.pindex_ids && Array.isArray(formData.pindex_ids)) {
            formData.pindex_ids = JSON.stringify(formData.pindex_ids);
          }

          this.$myhttp
            .post("contract/InvoiceDisc/saveInvoiceDisc", formData, {
              "Content-Type": "application/x-www-form-urlencoded",
            })
            .then((backdata) => {
              if (backdata.data.code == 0) {
                this.$message.success(backdata.data.msg || "保存成功");
                this.search(1);
                this.handleClose();
              } else {
                this.$message.error(backdata.data.msg || "保存失败");
              }
            })
            .catch((err) => {
              this.$message.error(err);
            });
        } else {
        }
      });
    },
    search(page) {
      this.searchForm.page = page;
      this.$myhttp
        .get("contract/InvoiceDisc/getInvoiceDiscList", {
          params: this.searchForm,
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.listData = backdata.data.data.list || [];
            this.searchForm.totalCount = backdata.data.data.total || 0;
          } else {
            this.$message.error(backdata.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    modals() {
      // 先初始化为空表单
      this.form = {
        id: 0,
        name: "",
        tax_number: "",
        address: "",
        bank: "",
        bank_account: "",
        tel: "",
        drawer: "",
        payee: "",
        inspector: "",
        remark: "",
        invoice_client: "",
        is_digitization: false,
        auth_id: "",
        app_key: "",
        app_secret: "",
        user_name: "",
        password: "",
        user_salt: "",
        electron_invoice_client: "",
        sort: 0,
        contract_area_id: "",
        pindex_ids: [],
      };

      // 请求默认值接口
      this.$myhttp
        .get("contract/InvoiceDisc/getDefaultInvoiceApp", {})
        .then((backdata) => {
          if (backdata.data.code == 0) {
            const defaultData = backdata.data.data;
            // 将默认值填充到表单中
            if (defaultData) {
              this.form.app_key = defaultData.app_key || '';
              this.form.app_secret = defaultData.app_secret || '';
              this.form.user_name = defaultData.user_name || '';
              this.form.password = defaultData.password || '';
              this.form.user_salt = defaultData.user_salt || '';
              this.form.auth_id = defaultData.auth_id || '';
            }
            this.modal = true;
          } else {
            // 如果获取默认值失败，仍然显示表单
            this.modal = true;
          }
        })
        .catch((err) => {
          // 如果请求失败，仍然显示表单
          this.modal = true;
          console.error('获取默认值失败:', err);
        });
    },
    handleClose() {
      this.modal = false;
    },
    edit(id) {
      this.modal = true;
      this.view(id);
    },
    view(id) {
      this.$myhttp
        .get(
          "contract/InvoiceDisc/getInvoiceDiscInfo",
          {
            params: { id },
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 0) {
            const data = backdata.data.data;
            // 解析 pindex_ids 为数组
            if (data.pindex_ids) {
              try {
                data.pindex_ids = typeof data.pindex_ids === 'string'
                  ? JSON.parse(data.pindex_ids)
                  : data.pindex_ids;
              } catch (e) {
                data.pindex_ids = [];
              }
            }
            this.form = data;
            this.defaultCheckedKeys = data.pindex_ids && data.pindex_ids.length > 0
              ? data.pindex_ids
              : [];
            if (this.pindexModal === true) {
              this.$refs.tree.setCheckedKeys(this.defaultCheckedKeys);
            }
          } else {
            this.$message.error(backdata.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    del(id) {
      this.$confirm("确定要删除该税盘吗", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$myhttp
          .post(
            "contract/InvoiceDisc/deleteInvoiceDisc",
            { id },
            {
              "Content-Type": "application/x-www-form-urlencoded",
            }
          )
          .then((backdata) => {
            if (backdata.data.code == 0) {
              this.search(1);
              this.$message.success(backdata.data.msg || "删除成功");
            } else {
              this.$message.error(backdata.data.msg || "删除失败");
            }
          })
          .catch((err) => {
            this.$message.error(err);
          });
      });
    },
    digitization(row) {
      this.digitizationModel = true;
      this.discId = row.id;
    },
    closeDigitization() {
      this.digitizationModel = false;
      this.discId = "";
    },
    searchArea(keyword) {
      if (keyword) {
        this.areaLoading = true;
        Area.getAreaList({ keyword: keyword }, (res) => {
          this.areaLoading = false;
          if (res && res.code === 0 && res.data) {
            this.areaOptions = res.data.map(item => ({
              id: item.id,
              name: item.name
            }));
          } else {
            this.areaOptions = [];
          }
        });
      } else {
        this.areaOptions = [];
      }
    },
  },
};
</script>

<style scoped lang="scss">
.pages {
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
  margin-right: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Contract/InvoiceSetting.vue